import { pick, joinPath } from "@constructor/services";
import { c as cleanSlash } from "./path.js";
function processResolver(resolver, to) {
  const result = resolver(to);
  if (!result) {
    return;
  }
  const { path, query } = splitUrl(result);
  return {
    ...pick(to, ["hash", "replace", "force"]),
    path,
    query: { ...query, ...to.query }
  };
}
function isRouteLocationNameObject(to) {
  return typeof to === "object" && "name" in to;
}
function normalizeLocation(to, options) {
  const commonProps = ["query", "hash", "replace", "force"];
  if (isRouteLocationNameObject(to)) {
    const result = pick(to, ["name", "params", ...commonProps]);
    if (options.nameResolver) {
      const resolvedResult = processResolver(options.nameResolver, result);
      if (resolvedResult) {
        return resolvedResult;
      }
    }
    return result;
  }
  const route = typeof to === "string" ? { path: to } : pick(to, ["path", ...commonProps]);
  if ("path" in route) {
    if (!route.path) {
      throw new Error(`Fragment can't set "path" param to empty string`);
    }
    route.path = joinPath(options.base, route.path);
  }
  return route;
}
function splitUrl(url) {
  const [path, query] = url.split("?");
  const result = { path };
  if (query) {
    result.query = convertSearchToQuery(query);
  }
  return result;
}
function convertSearchToQuery(search) {
  if (!search) {
    return {};
  }
  const query = {};
  for (const [key, value] of new URLSearchParams(search)) {
    if (!(key in query)) {
      query[key] = value;
      continue;
    }
    if (!Array.isArray(query[key])) {
      query[key] = [query[key]];
    }
    query[key] = [...query[key], value];
  }
  return query;
}
function removeBase(path, base) {
  return joinPath("/", path.slice(base.length));
}
function normalizeBase(base) {
  return base && cleanSlash(base) || "/";
}
function mergeBases(base1, base2) {
  return cleanSlash(joinPath(base1 ?? "/", base2 ?? "/")) || "/";
}
export {
  normalizeLocation as a,
  convertSearchToQuery as c,
  isRouteLocationNameObject as i,
  mergeBases as m,
  normalizeBase as n,
  removeBase as r,
  splitUrl as s
};
//# sourceMappingURL=router.js.map
